export { SmartVideoConnector as SmartVideo } from './src/smart-video-connector';
export { SmartVideoEditor } from './src/smart-video-editor';
export { smartVideoValidator } from './src/smart-video-validator';
